<template>
  <div>
    <div v-if="showList">
      <Card v-if="loading" :loadingState="true"></Card>
      <div v-if="!loading">
        <QuoteTile
          v-for="quoteId of quotes.keys()"
          :key="quoteId"
          :quote-id="quoteId"
          :motorQuote="quotes.get(quoteId)!"
          :isDetailHeader="false"
          :partner-proxy-id="partnerProxyId"
        ></QuoteTile>
        <Card
          v-if="quotes.size > 0"
          :title="$t('quoteList.missingContractsTitle')"
          :background-color-card="true"
          ><template #content
            ><p v-dompurify-html="$t('quoteList.missingContractsMessage')"></p></template
        ></Card>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ShowOrDeleteQuotes } from '@/types/policy/PolicyTypes'
import { onBeforeMount, ref, type Ref } from 'vue'
import { usePoliciesStore } from '@/stores/policiesStore'
import QuoteTile from '@/components/quote/QuoteTile.vue'
import { Card } from 'de-zurich-ui-library'

const props = defineProps({
  partnerProxyId: {
    type: String,
    required: true
  }
})
const quotes: Ref<Map<string, ShowOrDeleteQuotes>> = ref(
  new Map<string, ShowOrDeleteQuotes>()
)
const showList = ref(true)
const loading = ref(true)

onBeforeMount(async () => {
  quotes.value = await usePoliciesStore().getQuoteDetailsMapByPartnerProxyId(
    props.partnerProxyId
  )

  // if the map size is greater zero, showlist will be false
  // in any other case the list will be shown
  showList.value = quotes.value.size > 0

  loading.value = false
})
</script>
